import { inject, Injectable } from '@angular/core';
import {
  ArchiveFile,
  ArchiveStore,
  isArchivePreview,
  SOFTLINE_FEATURE_ARCHIVE,
} from '@softline/application';
import { Store } from '@softline/core';
import { MessageBarService, modalFn, PreviewHandler } from '@softline/ui-core';
import { FileViewerModal } from '@softline/ui-core/file-viewer';

@Injectable()
export class ArchivePdfPreviewHandler implements PreviewHandler {
  private readonly store = inject(Store);
  private readonly messageBar = inject(MessageBarService);
  private readonly modal = modalFn();

  canOpen(value: unknown): boolean {
    return isArchivePreview(value) && value.file?.metaData?.type === 'application/pdf';
  }

  async open(value: unknown): Promise<void> {
    if (!isArchivePreview(value)) return;
    await this.openPdf(value.file);
  }

  async openPdf(file: ArchiveFile): Promise<void> {
    await this.modal({
      component: FileViewerModal,
      dismiss: true,
      class: 'wide tall',
      flushContent: true,
      title: file.metaData?.name,
      subtitle: file.metaData?.summary,
      icon: 'fa-regular fa-file-pdf',
      data: {
        file: this.download(file),
        mimeType: 'application/pdf',
        fileName: file.metaData?.name ?? '',
      },
    });
  }

  private async download(file: ArchiveFile): Promise<Blob> {
    return this.store
      .dispatch(SOFTLINE_FEATURE_ARCHIVE, ArchiveStore.actions.downloadOnce, { file })
      .then((download) => download.content)
      .catch((e) => {
        this.messageBar.error('#APPLICATION.ARCHIVE.MESSAGES.DOWNLOAD_FAILURE');
        throw e;
      });
  }
}
